<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_CLS = `${PREFIX_CLASS}collapse`
export default {
  name: 'TCollapse',
  props: {
    mode: {
      type: String,
      default: '',
      validator(val) {
        return ['', 'accordion'].includes(val)
      }
    },
    value: {
      type: [String, Array],
      default: ''
    },
    type: {
      type: String,
      default: '',
      validator(val) {
        return ['', 'colorless', 'borderless'].includes(val)
      }
    }
  },
  data() {
    return {
      currentVal: this.value
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIX_CLS}-panels`,
        {
          [`${PREFIX_CLS}-panels-colorless`]: this.type === 'colorless',
          [`${PREFIX_CLS}-panels-borderless`]: this.type === 'borderless'
        }
      ]
    }
  },
  watch: {
    value(newVal) {
      this.currentVal = newVal
    },
    currentVal() {
      this.$_setPanelActive()
    }
  },
  mounted() {
    this.$_setPanelActive()
  },
  methods: {
    $_setPanelActive() {
      const activedKeys = this.$_getActivedKeys()
      this.$children.forEach((child, index) => {
        const name = child.name || index.toString()
        const actived =
          this.mode === 'accordion'
            ? activedKeys[0] === name
            : activedKeys.includes(name)
        child.active = actived
        child.index = index
      })
    },
    $_getActivedKeys() {
      let activedKeys = Array.isArray(this.currentVal)
        ? this.currentVal
        : [this.currentVal]
      const isAccordion = this.mode === 'accordion'
      if (isAccordion && activedKeys.length > 0) {
        activedKeys = activedKeys.slice(0, 1)
      }
      return activedKeys.map(k => k.toString())
    },
    toggleCollapse(child) {
      const name = child.name.toString()
      let next = []
      if (this.mode === 'accordion') {
        !child.active && (next = name)
      } else {
        next = this.$_getActivedKeys().slice()
        const index = next.indexOf(name)
        if (child.active) {
          index >= 0 && next.splice(index, 1)
        } else {
          index < 0 && next.push(name)
        }
      }
      this.currentVal = next
      this.$emit('input', next)
      this.$emit('change', next)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/module/collapse/collapse.vue